import cartServicesHtml from './cartservices.component.html';
import './cartservices.component.scss';

class CartServicesController {
    constructor($scope, $http, CartService, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;
        this.service = CartService;
    }

    $onInit() {
    }

    buy(product) {
        product.loading = true;
        this.$http.post(
            '/ajax/checkout/add-to-cart',
            {
                productId: parseInt(product.id),
                variantId: product.variant_id ? product.variant_id : 0,
                quantity: 1,
                voucher: null
            }
        ).then(
            response => {
                if (response.data.message && response.data.message.type != 'success') {
                    const message = response.data.message.content;
                    this.SnackbarService.add(message, 'error', true, 3000);
                    return;
                }

                this.SnackbarService.add(response.data.message.content, 'success', true, 3000);
                this.service.load();
                product.loading = false;
            },
            response => {
                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
                product.loading = false;
            }
        );
    }
}

let cartServicesComponent = {
    bindings: {},
    template: cartServicesHtml,
    controller: CartServicesController
}

export default cartServicesComponent;
